import { debounce } from 'lodash-es';
import { onUnmounted, ref, watch } from 'vue';
import { useUserEnvStore } from '@/common/stores/user-env';

export const usePersistedToggle = (envKey: string, defaultValue = true) => {
  if (!envKey) {
    return {
      isToggled: ref(defaultValue),
    };
  }

  const userEnvStore = useUserEnvStore();

  const isToggled = ref<boolean>(userEnvStore.getEnvValue<boolean>(envKey) ?? defaultValue);

  const debouncedSave = debounce((val: boolean) => {
    userEnvStore.setEnvValue([{ key: envKey, value: JSON.stringify(val) }]);
  }, 300);

  watch(isToggled, (val) => {
    debouncedSave(val);
  });

  onUnmounted(() => {
    debouncedSave.flush();
  });

  return { isToggled };
};
